import { render, staticRenderFns } from "./STLView.vue?vue&type=template&id=2b2041ad&"
import script from "./STLView.vue?vue&type=script&lang=js&"
export * from "./STLView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports